import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { GetRedirectsByExperienceIdResponseBodyType } from "@intelligems/ig-types";
import { selectedExperience } from "@src/store/slices/experiences";
import {
  initUrlRedirectsState,
  selectedRedirectsState,
} from "@src/store/slices/redirects";
import { selectedVariationsState } from "@src/store/slices/variations";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";

export const redirectKeys = {
  all: [{ scope: "redirects" }] as const,
  byExperience: (experienceId: string) =>
    [{ scope: "redirects", experienceId }] as const,
};
export const getRedirectsByExperienceId = async (
  experienceId: string
): Promise<GetRedirectsByExperienceIdResponseBodyType> => {
  const resp = await api.get<GetRedirectsByExperienceIdResponseBodyType>(
    `/v2/redirects/experience/${experienceId}`
  );
  return resp.data;
};
export const useRedirectsByExperienceId = (
  experienceId: string | undefined
) => {
  return useQuery<GetRedirectsByExperienceIdResponseBodyType, Error>({
    queryKey: redirectKeys.byExperience(experienceId!),
    queryFn: async () => getRedirectsByExperienceId(experienceId!),
    enabled: Boolean(experienceId),
  });
};

export const useAndSetRedirectsByExperienceId = () => {
  const dispatch = useDispatch();
  const redirectState = useSelector(selectedRedirectsState);
  const variations = useSelector(selectedVariationsState);
  const experience = useSelector(selectedExperience);

  useEffect(() => {
    if (
      redirectState.redirects.length === 0 &&
      experience?.type === "content/url" &&
      experience?.actionMode === "create" &&
      variations.variations.length > 0
    ) {
      // Initialize URL redirect
      dispatch(
        initUrlRedirectsState({
          variations: variations.variations,
        })
      );
    }
  }, [experience?.type, variations.isSuccess, experience?.actionMode]);

  return redirectState;
};
